import { useDropzone } from 'react-dropzone';

import { useConfirmImageReplace } from '@/views/build/hook/useConfirmImageReplace';

export const useDroppableImageUploadInput = ({
  disabled,
  accept,
  onFileChange,
  imageUrl,
}: {
  disabled?: boolean;
  onFileChange: (file: File | null) => void;
  accept: string;
  imageUrl?: string;
}) => {
  const { confirm } = useConfirmImageReplace();

  const { getRootProps, getInputProps, isDragActive, inputRef } = useDropzone({
    onDrop: (files: File[]) => {
      void (async () => {
        if (!imageUrl) {
          onFileChange(files[0]);
          return;
        }
        const shouldReplaceImage = await confirm();
        if (!shouldReplaceImage) return;
        onFileChange(files[0]);
      })();
    },
    noClick: true,
    noKeyboard: true,
    disabled,
  });

  return {
    rootProps: { ...getRootProps() },
    inputProps: { ...getInputProps(), accept },
    isDragActive,
    inputRef,
  };
};
